import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import React, { FC, useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { ReactComponent as DeleteIcon } from 'assets/icons/remove-modal.svg';
import { handleApiError } from 'utils/functions';
import { EventGuestType } from 'models/guest.model';

type RefundModalType = { show: boolean; onClose: () => void; guests: EventGuestType[] };
interface DeletePeopleFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const RefundModalFooter: FC<DeletePeopleFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);
const RefundModal: FC<RefundModalType> = ({ show, onClose, guests }) => {
  const [loading, setLoading] = useState(false);
  const refund = async () => {
    setLoading(true);
    try {
      const res = await apiService.post('guest/debit-wallet', {
        data: {
          guest_id: guests?.[0].id
        }
      });
      if (res.data) {
        toast(<ToastMessage type='success' message='Refund successful' />);
        onClose();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <LocalModal
        isOpen={show}
        title=''
        titleIconColor='danger'
        onRequestClose={() => onClose()}
        footer={
          <RefundModalFooter loading={loading} onCancel={() => onClose()} onConfirm={refund} />
        }>
        <div className='flex flex-col justify-center items-center'>
          <DeleteIcon className='text-red-5 mx-auto mb-4' />

          <p className='text-[#2E3031] text-center mb-1 capitalize'>
            {`Are you sure you want to withdraw funds from ${guests?.[0]?.first_name} ${guests?.[0]?.last_name} wallet `}
          </p>
        </div>
      </LocalModal>
    </div>
  );
};

export default RefundModal;
